import { useState, useEffect, useCallback } from 'react'
import axios from 'axios'
import { useAuth } from '../context/AuthContext'

export function useCoinBalance() {
  const { user, getToken } = useAuth()
  const [balance, setBalance] = useState(0)
  const [purchasedBalance, setPurchasedBalance] = useState(0)
  const [earnedBalance, setEarnedBalance] = useState(0)
  const [heldBalance, setHeldBalance] = useState(0)
  const [redeemableBalance, setRedeemableBalance] = useState(0)
  const [loading, setLoading] = useState(true)

  const refresh = useCallback(async () => {
    if (!user) { setBalance(0); setPurchasedBalance(0); setEarnedBalance(0); setHeldBalance(0); setRedeemableBalance(0); setLoading(false); return }
    try {
      const token = await getToken()
      if (!token) { setLoading(false); return }
      const { data } = await axios.get('/api/coins/balance', {
        headers: { Authorization: `Bearer ${token}` },
      })
      setBalance(data.balance ?? 0)
      setPurchasedBalance(data.purchasedBalance ?? 0)
      setEarnedBalance(data.earnedBalance ?? 0)
      setHeldBalance(data.heldBalance ?? 0)
      setRedeemableBalance(data.redeemableBalance ?? 0)
    } catch (err) {
      console.error('[useCoinBalance] Failed to fetch coin balance:', err)
    } finally {
      setLoading(false)
    }
  }, [user?.id]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    refresh()
  }, [refresh])

  return { balance, purchasedBalance, earnedBalance, heldBalance, redeemableBalance, loading, refresh }
}
